import { Field, Label, Switch } from '@headlessui/react';
import React, { useState } from 'react'

export default function DesignSelector({
    auctionData,
    setAuctionData,
    setEditedAuctionData,
}) {
    const [enabledLeaderboard, setEnabledLeaderboard] = useState(auctionData?.event_display?.enable_leaderboard || false)
    const [enableCarousel, setEnableCarousel] = useState(auctionData?.event_display?.enable_carousel || false)

    const handleEnableCarousel = (checked) => {
        setEnableCarousel(checked)
        setAuctionData((prevData) => ({
            ...prevData,
            event_display: {
                ...prevData.event_display,
                enable_carousel: checked,
            }
        }))
        setEditedAuctionData((prevData) => ({
            ...prevData,
            event_display: {
                ...prevData.event_display,
                enable_carousel: checked,
            }
        }))
    }

    const handleEnableLeaderboard = (checked) => {
        setEnabledLeaderboard(checked)
        setAuctionData((prevData) => ({
            ...prevData,
            event_display: {
                ...prevData.event_display,
                enable_leaderboard: checked,
            }
        }))
        setEditedAuctionData((prevData) => ({
            ...prevData,
            event_display: {
                ...prevData.event_display,
                enable_leaderboard: checked,
            }
        }))
    }

    return (
        <div className="px-2 pt-5">
            <Field className="pt-4 flex items-center">
                <Switch
                    checked={enabledLeaderboard}
                    data-testid="enable-leaderboard-switch"
                    onChange={handleEnableLeaderboard}
                    className="group inline-flex h-6 w-11 items-center rounded-full
                        bg-gray-300 data-[checked]:bg-black mr-2"
                >
                    <span className="inline-block size-4 transform rounded-full bg-white transition 
                        group-data-[checked]:translate-x-6 translate-x-1" />
                </Switch>
                <Label>Enable Leaderboard</Label>
            </Field>
            <Field className="pt-4 flex items-center">
                <Switch
                    checked={enableCarousel}
                    data-testid="enable-carousel-switch"
                    onChange={handleEnableCarousel}
                    className="group inline-flex h-6 w-11 items-center rounded-full
                        bg-gray-300 data-[checked]:bg-black mr-2"
                >
                    <span className="inline-block size-4 transform rounded-full bg-white transition 
                        group-data-[checked]:translate-x-6 translate-x-1" />
                </Switch>
                <Label>Enable Carousel</Label>
            </Field>

        </div>
    )
}
